import { useState } from 'react';
import { CheckCircle, Copy } from 'lucide-react';

/** A read-only value with a copy button — URLs to paste into a vendor's console. */
export default function CopyField({ value }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="flex items-center gap-2">
      <code className="flex-1 truncate rounded bg-neutral-100 px-2 py-1 text-xs text-neutral-800 dark:bg-neutral-900 dark:text-neutral-200">{value || '—'}</code>
      {value && (
        <button
          type="button"
          onClick={async () => {
            try {
              await navigator.clipboard.writeText(value);
              setCopied(true);
              setTimeout(() => setCopied(false), 1500);
            } catch {
              /* clipboard unavailable */
            }
          }}
          className="text-neutral-400 hover:text-neutral-700 dark:hover:text-neutral-200"
          title="Copy"
        >
          {copied ? <CheckCircle className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
        </button>
      )}
    </div>
  );
}
